import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/header.svg'
import _imports_1 from '@/assets/logo.svg'
import _imports_2 from '@/assets/profile.svg'


const _withScopeId = n => (_pushScopeId("data-v-6d827b87"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<header class=\"w-full h-20\" data-v-6d827b87><img src=\"" + _imports_0 + "\" alt=\"Vue logo\" class=\"h-20 absolute -z-10 object-cover w-full\" data-v-6d827b87><div class=\"container\" data-v-6d827b87><nav data-v-6d827b87><ul class=\"flex\" data-v-6d827b87><li data-v-6d827b87><a href=\"#\" class=\"text-base text-white\" data-v-6d827b87><img src=\"" + _imports_1 + "\" alt=\"Logo\" class=\"h-8\" data-v-6d827b87></a></li><li class=\"flex-1\" data-v-6d827b87></li><li class=\"ml-8\" data-v-6d827b87><a href=\"/module.html\" class=\"text-base text-white leading-[36px]\" data-v-6d827b87>Weiter Machen</a></li><li class=\"ml-8\" data-v-6d827b87><a href=\"/module.html\" class=\"text-base text-white leading-[36px]\" data-v-6d827b87>Meine Module</a></li><li class=\"mx-8\" data-v-6d827b87><div class=\"border-r-2 border-white h-[36px]\" data-v-6d827b87></div></li><li data-v-6d827b87><a href=\"#\" class=\"text-base\" data-v-6d827b87><img src=\"" + _imports_2 + "\" alt=\"User\" class=\"h-8\" data-v-6d827b87></a></li></ul></nav></div></header>", 1)
const _hoisted_2 = { class: "container flex mt-16" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-play rotate-180 mr-2" }, null, -1))
const _hoisted_4 = { class: "p-0 left-navigation sticky top-10" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["href", "onClick"]
const _hoisted_7 = { class: "flex-auto px-4" }
const _hoisted_8 = { class: "mb-10 onecol:hidden" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-play mr-2 rotate-180" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear-both" }, null, -1))
const _hoisted_11 = { class: "mt-10" }
const _hoisted_12 = { class: "block uppercase text-xl" }
const _hoisted_13 = { class: "flex gap-4" }
const _hoisted_14 = { class: "h1 text-left" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-auto" }, null, -1))
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex onecol:hidden" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-cloud-arrow-down text-gray-500 text-3xl self-center h-8 cursor-not-allowed" })
], -1))
const _hoisted_19 = { class: "mt-5" }
const _hoisted_20 = {
  key: 0,
  src: "https://www.youtube.com/embed/meTpMP0J5E8",
  title: "YouTube video player",
  frameborder: "0",
  allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
  allowfullscreen: "",
  class: "w-full rounded-3xl aspect-video"
}
const _hoisted_21 = { class: "mt-5" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-play ml-2" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear-both" }, null, -1))
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<section class=\"text-left\" id=\"kommentare\" data-v-6d827b87><h1 class=\"h1 mt-20\" data-v-6d827b87>Kommentare</h1><h3 class=\"mt-2\" data-v-6d827b87>Schreibe hier einen Kommentar</h3><textarea class=\"w-full h-40 mt-5 border-pink border-2 rounded-3xl p-5\" placeholder=\"Stelle eine Frage oder gebe Feedback zu diesem Modul...\" data-v-6d827b87></textarea><button class=\"float-right mt-5\" data-v-6d827b87>Senden <i class=\"fa-solid fa-paper-plane ml-2\" data-v-6d827b87></i></button><div class=\"clear-both\" data-v-6d827b87></div></section>", 1)
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "h-80 bg-slate-900 mt-28" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArticleSection = _resolveComponent("ArticleSection")!
  const _component_Comment = _resolveComponent("Comment")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex-[0_0_350px] px-4 text-left mt-10 hidden bg-white z-40", _ctx.navbarExpanded ? '!block absolute inset-0 top-20 px-8 pt-7' : 'onecol:block'])
      }, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.navbarExpanded = !_ctx.navbarExpanded)),
          class: "onecol:hidden"
        }, [
          _hoisted_3,
          _createTextVNode("Zurück ")
        ]),
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MODULE_DATA.sections, (section) => {
              return (_openBlock(), _createElementBlock("li", {
                key: section.title
              }, [
                _createElementVNode("h2", {
                  class: _normalizeClass(["h3 cursor-pointer hover:opacity-80", _ctx.currentModule.title === section.title ? 'font-gradient-cta' : '']),
                  onClick: ($event) => ((_ctx.currentModule = section), (_ctx.navbarExpanded = false))
                }, _toDisplayString(section.title), 11, _hoisted_5),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.subsections, (subsection) => {
                  return (_openBlock(), _createElementBlock("a", {
                    href: `#${subsection.id}`,
                    key: subsection.id,
                    onClick: ($event) => ((_ctx.currentModule = section), (_ctx.navbarExpanded = false))
                  }, [
                    _createTextVNode(_toDisplayString(subsection.title), 1),
                    (subsection?.icon)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass(["fa-solid float-right leading-7", subsection?.icon])
                        }, null, 2))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_6))
                }), 128))
              ]))
            }), 128))
          ])
        ])
      ], 2),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "float-left",
            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.navbarExpanded = !_ctx.navbarExpanded))
          }, [
            _hoisted_9,
            _createTextVNode("Übersicht ")
          ]),
          _hoisted_10
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("section", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.MODULE_DATA.title), 1),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h1", _hoisted_14, _toDisplayString(_ctx.currentModule.title), 1),
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("i", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onStopAudio && _ctx.onStopAudio(...args))),
                  class: _normalizeClass(["fa-solid fa-stop font-gradient-cta text-3xl self-center h-8 cursor-pointer", _ctx.isSpeaking ? '' : 'hidden'])
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("i", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPlayAudio && _ctx.onPlayAudio(...args))),
                  class: _normalizeClass(["fa-solid fa-headphones-simple font-gradient-cta text-3xl self-center h-8 cursor-pointer", _ctx.isSpeaking ? (_ctx.isPaused ? 'fa-play' : 'fa-pause') : 'fa-headphones-simple'])
                }, null, 2)
              ]),
              _hoisted_18
            ])
          ]),
          _createElementVNode("section", _hoisted_19, [
            false
              ? (_openBlock(), _createElementBlock("iframe", _hoisted_20))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("section", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentModule.paragraphs, (section) => {
              return (_openBlock(), _createBlock(_component_ArticleSection, {
                key: section.text,
                section: section
              }, null, 8, ["section"]))
            }), 128))
          ]),
          _createElementVNode("section", null, [
            (_ctx.nextModule?.title)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "float-right mt-5",
                  onClick: _cache[4] || (_cache[4] = ($event) => ((_ctx.currentModule = _ctx.nextModule), (_ctx.navbarExpanded = false)))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.nextModule.title) + " ", 1),
                  _hoisted_22
                ]))
              : _createCommentVNode("", true),
            _hoisted_23
          ]),
          _hoisted_24,
          _createVNode(_component_Comment, {
            class: "mt-20",
            name: "Lena Mustermann",
            profilepic: "/images/profilepic1.png",
            area: "Einführung",
            role: "Studentin",
            time: "vor 2 Stunden",
            message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nunc vel tincidunt lacinia, nisl nunc aliquet nunc, vel lacinia nunc nisl eget nunc.",
            nested: false
          }),
          _createVNode(_component_Comment, {
            name: "Max Mustermann",
            profilepic: "/images/profilepic2.png",
            area: "Global",
            role: "Tutor",
            time: "vor 1 Stunde",
            message: "@lena_mustermann Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nunc vel tincidunt lacinia, nisl nunc aliquet nunc, vel lacinia nunc nisl eget nunc.",
            nested: true
          })
        ])
      ])
    ]),
    _hoisted_25
  ], 64))
}